import React from 'react';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { ContentfulSupportedLangs } from '@ha/contentful';
import { FeaturedCountries as countries } from 'ha/constants/FeaturedCountries';

import {
  FeaturedLinksWrapper,
  FeaturedLinksTitle,
  FeaturedLinksContent,
  FeaturedLink,
} from '../FeaturedLinks/FeaturedLinks';

export const FeaturedCountries: React.FC = () => {
  const { T, urlResolver, lang } = useIntl();
  const { lg } = useMediaQuery();

  const translatedCountries = [
    T('home.in_country.Austria'),
    T('home.in_country.Belgium'),
    T('home.in_country.Canada'),
    T('home.in_country.CzechRepublic'),
    T('home.in_country.France'),
    T('home.in_country.Germany'),
    T('home.in_country.Greece'),
    T('home.in_country.Hungary'),
    T('home.in_country.Iceland'),
    T('home.in_country.Ireland'),
    T('home.in_country.Italy'),
    T('home.in_country.Netherlands'),
    T('home.in_country.Poland'),
    T('home.in_country.Portugal'),
    T('home.in_country.Spain'),
    T('home.in_country.Switzerland'),
    T('home.in_country.UnitedKingdom'),
    T('home.in_country.UnitedStates'),
  ];

  const countriesLinks: FeaturedLink[] = countries.map((country, index) => {
    const translatedCountryName = translatedCountries[index];
    const countryUrl = ContentfulSupportedLangs.includes(lang)
      ? translatedCountryName
      : country.name;
    return {
      textContent: translatedCountryName,
      url: urlResolver.getCountryUrl(countryUrl.replace(/ /g, '-')),
      title: translatedCountryName,
    };
  });

  const maxItemsPerColumn = lg ? 1 : 8;
  const columnWidth = 1;

  return (
    <FeaturedLinksWrapper slightlyGray>
      <FeaturedLinksTitle titles={[T('home_page_featured_countries')]} />
      <FeaturedLinksContent
        items={countriesLinks}
        maxItemsPerColumn={maxItemsPerColumn}
        columnWidth={columnWidth}
      />
    </FeaturedLinksWrapper>
  );
};
